exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-password-form{position:relative}.new-password-form__description,.new-password-form__check-item{display:block;margin-bottom:12px;font-size:15px;line-height:24px;color:#333}.new-password-form__check-item{position:relative;padding-left:30px}.new-password-form__check{position:absolute;top:0;left:0;width:20px;height:20px;background:rgba(51,119,187,.08);border-radius:50%}.new-password-form__check.active{background:#5bb161}.new-password-form__check-icon{position:absolute;top:0;left:4px}.new-password-form__check-icon svg{width:13px;height:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/login-page/login/new-password-form/style.scss
// module id = 1360
// module chunks = 57